import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=6b8bfa5f&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=6b8bfa5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8bfa5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b8bfa5f')) {
      api.createRecord('6b8bfa5f', component.options)
    } else {
      api.reload('6b8bfa5f', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=6b8bfa5f&scoped=true&", function () {
      api.rerender('6b8bfa5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Bs51WByZ7SeV/JS/comp/DateRangeExt.vue"
export default component.exports